class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.cartDiscountProgressBar();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
    this.cart =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    this.checkUpsellCheckboxes();
    //this.cartUpsellFilter();
    this.soldOutMessageWrapper = this.querySelector(
      ".Drawer__upsellsSoldOutMessage--Wrapper"
    );
    // select all checkboxes with class "upsellATCCheckbox"
    const upsellAddBtns = document.querySelectorAll(".upsell__add-btn");

    upsellAddBtns.forEach((evt) => {
      evt.addEventListener("click", this.cartDrawerUpsellHandler.bind(this));
    });
    // Call the checkCartStatus function on page load
    document.addEventListener("DOMContentLoaded", (event) => {
      this.checkCartStatus();
    });
    this.hideBundleUpsellProducts();
    this.savingsCalculator();
  }
  checkCartStatus() {
    // Use fetch to get the cart data
    fetch("/cart.js", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((cart) => {
        // Check if the cart is empty
        const isEmpty = cart.item_count === 0;
        // Select the cart-drawer element
        const cartDrawer = document.querySelector("cart-drawer");
        // Toggle the is-empty class on the cart-drawer element based on the cart status
        if (cartDrawer) {
          cartDrawer.classList.toggle("is-empty", isEmpty);
        }
      })
      .catch((error) => console.error(error));
  }
  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0
          );

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`)
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a")
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name")
          );
        }
        this.disableLoading();
      })
      .catch(() => {
        this.querySelectorAll(".loading-overlay").forEach((overlay) =>
          overlay.classList.add("hidden")
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) ||
        document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement =
        document.getElementById(`Quantity-${line}`) ||
        document.getElementById(`Drawer-quantity-${line}`);
      lineItemError.querySelector(".cart-item__error-text").innerHTML =
        window.cartStrings.quantityError.replace(
          "[quantity]",
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
    setTimeout(() => {
      this.cartDiscountProgressBar();
    }, 2000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper =
      this.errorMessageWrapper ||
      this.querySelector(".Drawer__upsellsErrorMessage--Wrapper");
    if (!this.errorMessageWrapper) return;
    this.errorMessage =
      this.errorMessage ||
      this.errorMessageWrapper.querySelector(".Drawer__upsellsErrorMessage");

    this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
  cartDiscountProgressBar() {
    const progressBar = document.querySelector(
      ".CartDrawer-gamification-progress-bar"
    );
    const steps = document.querySelectorAll(".CartDrawer-gamification-step");
    const moneyInput = document.querySelector(".drawer__footer");

    const enteredMoney = moneyInput
      .getAttribute("data-subtotal")
      .replace(",", "");

    if (!isNaN(enteredMoney)) {
      const totalMoney = parseFloat(
        steps[steps.length - 1].getAttribute("data-step-amount")
      );
      const progress = Math.min(enteredMoney / totalMoney, 1);

      var progressCompletedElement =
        document.querySelector(".progressCompleted");
      var progressOngoingElement = document.querySelector(".progressOngoing");

      steps.forEach(function (step) {
        const stepAmount = parseFloat(step.getAttribute("data-step-amount"));
        if (enteredMoney >= stepAmount) {
          step.classList.add("step-completed");
          const nextStep = step.nextElementSibling;
          if (nextStep) {
            const nextStepReward = nextStep.querySelector(
              ".CartDrawer-gamification-step-content"
            ).textContent;
            const nextStepAmount = parseFloat(
              nextStep.getAttribute("data-step-amount")
            );
            const nextStepRemaining = Math.trunc(nextStepAmount - enteredMoney);

            document.querySelector(
              ".CartDrawer-gamification-next-remaining"
            ).textContent = "$" + nextStepRemaining;
            document.querySelector(
              ".CartDrawer-gamification-next-reward"
            ).textContent = nextStepReward;
          }
        } else {
          step.classList.remove("step-completed");
        }

        let progressBarWidth = progress * 100 + "%";

        if (enteredMoney > 110 && progress < 0.28) {
          progressBarWidth = "28.5%";
        } else if (enteredMoney >= 110 && enteredMoney <= 210) {
          if (progress > 0.6) {
            progressBarWidth = "60%";
          }
          if (progress > 0.95) {
            progressBarWidth = "95%";
          }
        }

        if (progress >= 1) {
          progressCompletedElement.style.display = "block";
          progressOngoingElement.style.display = "none";
        } else {
          progressCompletedElement.style.display = "none";
          progressOngoingElement.style.display = "block";
        }

        progressBar.style.maxWidth = progressBarWidth;
      });
    } else {
      steps.forEach(function (step) {
        step.classList.remove("step-completed");
        step.style.maxWidth = "0";
      });
    }
  }
  savingsCalculator() {
    // Find the element with the class "cart-items tbody"
    var cartItemsTable = document.querySelector(".cart-items tbody");

    // Check if the element is found
    if (cartItemsTable) {
      // Initialize the total variable
      var cartBeforeSavingsTotal = 0;

      // Loop over all child elements with class "cart-item"
      var cartItems = cartItemsTable.querySelectorAll(".cart-item");
      cartItems.forEach(function (cartItem) {
        // Get the data attribute "variant-compare-price"
        var variantComparePrice = cartItem.getAttribute(
          "data-variant-compare-price"
        );

        // Remove currency symbol and parse the money value
        var moneyValue = parseFloat(
          variantComparePrice.replace(/[^\d.-]/g, "")
        );

        // Get the quantity from the data attribute "quantity"
        var quantity = parseInt(cartItem.getAttribute("data-quantity"), 10);

        // Multiply moneyValue by quantity
        var itemTotal = moneyValue * quantity;

        // Add the item total to the overall total
        cartBeforeSavingsTotal += itemTotal;
      });
    }

    // Find the element with class "totals__subtotal-value"
    var cartTotalAfterSavingsElement = document.querySelector(
      ".totals__subtotal-value"
    );

    // Check if the element is found
    if (cartTotalAfterSavingsElement) {
      // Get the money value from the data attribute "cart-subtotal"
      var cartTotalAfterSavings = parseFloat(
        cartTotalAfterSavingsElement
          .getAttribute("data-cart-subtotal")
          .replace(/[^\d.-]/g, "")
      );

      // Calculate savings
      var savings = cartBeforeSavingsTotal - cartTotalAfterSavings;

      // Calculate percentage savings
      var percentageSavings = (savings / cartBeforeSavingsTotal) * 100;

      // Find the element with class "totals__savings-value"
      var savingsElement = document.querySelector(".totals__savings-value");

      // Check if the element is found
      if (savingsElement) {
        // Insert the savings values in the specified format
        savingsElement.textContent =
          "$" + savings.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        console.error('Element with class "totals__savings-value" not found.');
      }
    } else {
      console.error('Element with class "totals__subtotal-value" not found.');
    }
  }
  cartDrawerUpsellHandler(evt) {
    // get the target checkbox from the event object
    let checkbox = evt.target;

    // traverse up the DOM tree to find the parent element with class "upsell__product"
    let upsellProduct = checkbox.closest(".upsell__product");

    // get the attribute values of "data-product-id" and "data-section-url"
    const getUpsellProductId = upsellProduct.getAttribute("data-product-id");
    const getUpsellSectionUrl = upsellProduct.getAttribute("data-section-url");

    var data = {
      id: getUpsellProductId,
      quantity: 1,
      sections: ["cart-drawer", "cart-icon-bubble"],
      sections_url: getUpsellSectionUrl,
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.soldOutMessageWrapper.querySelector(
            ".Drawer__upsellsSoldOutMessage"
          );
          if (!soldOutMessage) return;
          soldOutMessage.classList.remove("hidden");
          this.error = true;
          return;
        }

        this.error = false;

        this.cart.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        if (this && this.classList.contains("is-empty"))
          this.classList.remove("is-empty");
      });
  }

  hideBundleUpsellProducts() {
    const upsellProductsWrapper = document.querySelector(".Drawer__upsells");
    const upsellProducts = document.querySelectorAll(".upsell__product");
    const cartItems = document.querySelectorAll(".cart-item");
    // Check if any cart item contains "Pro Bundle" in data-variant-title
    const hasProBundle = Array.from(cartItems).some((cartItem) => {
      const variantTitle = cartItem.getAttribute("data-variant-title");
      return variantTitle.includes("Pro Bundle");
    });

    if (hasProBundle) {
      // Loop through upsellProducts and hide specific ones
      upsellProducts.forEach((upsellProduct) => {
        const variantId = upsellProduct.getAttribute("data-product-id");
        // Hide products with data-variant-id values 1, 2, 9, and 10
        if (
          ["43868827877542", "44027160297638", "43773818044582"].includes(
            variantId
          )
        ) {
          upsellProduct.style.display = "none";
        }
      });
    }
  }
  checkUpsellCheckboxes() {
    const upsellProductsWrapper = document.querySelector(".Drawer__upsells");
    const upsellProducts = document.querySelectorAll(".upsell__product");
    const cartItems = document.querySelectorAll(".cart-item");

    upsellProducts.forEach((upsellProduct) => {
      const productId = upsellProduct.getAttribute("data-product-id");
      let foundMatch = false;
      cartItems.forEach((cartItem) => {
        const cartProductId = cartItem.getAttribute("data-product-id");

        if (productId === cartProductId) {
          foundMatch = true;
        }
      });

      if (foundMatch) {
        upsellProduct.style.display = "none";
      } else {
        upsellProduct.style.display = "flex";
      }
    });

    let allHidden = true;

    // Loop through each element
    for (let i = 0; i < upsellProducts.length; i++) {
      // Check if the element has display: none set
      if (upsellProducts[i].style.display !== "none") {
        allHidden = false;
        break;
      }
    }

    // Check if all elements have display: none set
    if (allHidden) {
      upsellProductsWrapper.style.display = "none";
    } else {
      upsellProductsWrapper.style.display = "block";
    }
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, 300)
        );
      }
    }
  );
}
